import { FileShape } from '@cibo/core'
import { ResponsiveDialog, ResponsiveDialogProps, useFiles } from '@cibo/ui'
import { Button, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material'
import { descend } from 'ramda'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { FilesTable } from './FilesTable'

type AddExistingFileModalProps = ResponsiveDialogProps & {
  handleAddExisting(item: FileShape): void
  maxSize?: number
  extensions?: string[]
}

export const AddExistingFileModal = (props: AddExistingFileModalProps) => {
  const { t } = useTranslation(['@cibo/programs/DataEntryFileUpload'])
  const { maxSize, extensions } = props

  const handleAdd = useCallback(
    (item: FileShape) => {
      props.handleAddExisting(item)

      props.onClose?.()
    },
    [props]
  )

  const files = useFiles()

  const fileList = files.data
    ?.filter(file => !maxSize || file.bytes <= maxSize)
    .filter(file => {
      const fileExtension = file.name
        .split('.')
        .pop()
        ?.toLowerCase()
      return !extensions || (fileExtension && extensions.includes(fileExtension))
    })
    .sort(descend(file => file.createdAt))

  return (
    <ResponsiveDialog {...props} maxWidth="lg" fullWidth>
      <DialogTitle>{t('addExistingFile')}</DialogTitle>

      <DialogContent>
        <FilesTable
          files={fileList}
          FileAction={({ file }: { file: FileShape }) => (
            <Tooltip title={t('addFile')}>
              <Button variant="contained" onClick={() => handleAdd(file)}>
                {t('addFile')}
              </Button>
            </Tooltip>
          )}
        />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={props.onClose}>
          {t('close')}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
